// Phones: the Employee Center page scrolls as a whole (the header scrolls
// away) instead of each tab filling the space under a pinned header with its
// own small scroll area. Spread into the sx of any container that fills the
// page height on larger screens; desktop and tablets are unchanged.
export const PHONE_MEDIA_QUERY = '@media (max-width: 599.95px)';

// The Employee Center main column (next to the employee list) is a size
// container with this name. When it is narrow (small window with the list
// open) it gets the phone layout too, even though the window isn't a phone's.
export const EMPLOYEE_PAGE_CONTAINER = 'employee-page';
export const NARROW_PAGE_QUERY = `@container ${EMPLOYEE_PAGE_CONTAINER} (max-width: 520px)`;

// The same styles on phones and in a narrow Employee Center column.
export const onPhoneOrNarrowPage = <T extends object>(sx: T) => ({
  [PHONE_MEDIA_QUERY]: sx,
  [NARROW_PAGE_QUERY]: sx,
});

export const naturalHeightOnPhoneSx = onPhoneOrNarrowPage({
  height: 'auto',
  minHeight: 'auto',
  flex: '0 0 auto',
  overflowY: 'visible',
} as const);
